import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../../App';
import './Sidebar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
   faChartLine,
   faPenNib,
   faSignOutAlt,
   faTaxi,
   faToolbox,
   faUserLock,
   faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import { faJediOrder } from '@fortawesome/free-brands-svg-icons';

const Sidebar = () => {
   const [loggedInUser, setLoggedInUser] = useContext(UserContext);
   const [admin, setAdmin] = useState([]);

   const checkMail = loggedInUser && loggedInUser?.email;
   
   useEffect(() => {
      fetch('https://cryptic-basin-05682.herokuapp.com/', {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json',
         },
         body: JSON.stringify({ checkMail }),
      })
         .then(res => res.json())
         .then(data => setAdmin(data));
   }, []);

   const adminMember = admin[0]?.email === checkMail;
   return (
      <div
         className="sidebar d-flex flex-column justify-content-between col-md-2 py-5 px-4"
         style={{ height: '100vh' }}
      >
         {!adminMember ? (
            <ul className="list-unstyled">
               <li>
                  <Link
                     to="/common"
                     className="text-white text-decoration-none"
                  >
                     <FontAwesomeIcon icon={faChartLine} />
                     Dashboard
                  </Link>
               </li>

               <li>
                  <Link
                     to="/services"
                     className="text-white text-decoration-none"
                  >
                     <FontAwesomeIcon icon={faTaxi} /> All Services
                  </Link>
               </li>

               <li>
                  <Link to="/order" className="text-white text-decoration-none">
                     <FontAwesomeIcon icon={faJediOrder} /> My Orders
                  </Link>
               </li>

               <li>
                  <Link
                     to="/addService"
                     className="text-white text-decoration-none"
                  >
                     <FontAwesomeIcon icon={faUserPlus} /> Add Service
                  </Link>
               </li>

               <li>
                  <Link
                     to="/addAnAdmin"
                     className="text-white text-decoration-none"
                  >
                     <FontAwesomeIcon icon={faUserLock} /> Add Admin
                  </Link>
               </li>

               <li>
                  <Link
                     to="/adminPanel"
                     className="text-white text-decoration-none"
                  >
                     <FontAwesomeIcon icon={faToolbox} /> All Admin
                  </Link>
               </li>

            </ul>
         ) : (
            <ul className="list-unstyled">
               <li>
                  <Link
                     to="/common"
                     className="text-white text-decoration-none"
                  >
                     <FontAwesomeIcon icon={faChartLine} />
                     Dashboard
                  </Link>
               </li>
               <li>
                  <Link
                     to="/myOrder"
                     className="text-white text-decoration-none"
                  >
                     <FontAwesomeIcon icon={faJediOrder} /> Added Orders
                  </Link>
               </li>
               <li>
                  <Link
                     to="/addReview"
                     className="text-white text-decoration-none"
                  >
                     <FontAwesomeIcon icon={faPenNib} /> Review
                  </Link>
               </li>
            </ul>
         )}
         <div>
            <Link to="/" className="text-white text-decoration-none">
               <span>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Logout
               </span>
            </Link>
         </div>
      </div>
   );
};

export default Sidebar;
